module.exports = __webpack_public_path__ + "static/img/achieve_ok.5700f02.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/achieve_ok.png
// module id = gCS5
// module chunks = 1